import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../../../Helper/ToastMessage";

export const WTPOperationalWorkTableDataAPI = createAsyncThunk("WTPOperationalWorkTableData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_WardID,
        M_WTP_LocationID,
        M_UserID,
        token,
        From,
        To,
        handleGetExport
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/Master/Get_WEB_WTP_T_WTP_MaintainanceWork_Preventive_Select?FromDate=${FromDate}&ToDate=${ToDate}&M_WardID=${M_WardID}&M_WTP_LocationID=${M_WTP_LocationID}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            // console.log(result.data1, result.data) 
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleGetExport && handleGetExport()
                return result.data

            } else {
                return result
            }
        })
})

const WTPOperationalWorkTableDataSlice = createSlice({
    name: "WTPOperationalWorkTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPOperationalWorkTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WTPOperationalWorkTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(WTPOperationalWorkTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const WTPOperationalWorkTableDataReducer = WTPOperationalWorkTableDataSlice.reducer

// Export Api

export const WTPOperationalWorkTableExportDataAPI = createAsyncThunk("WTPOperationalWorkTableExportData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_WardID,
        M_WTP_LocationID,
        M_UserID,
        token,
        From,
        To,
        handleGetExport
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/Master/Get_WEB_WTP_T_WTP_MaintainanceWork_Preventive_Select?FromDate=${FromDate}&ToDate=${ToDate}&M_WardID=${M_WardID}&M_WTP_LocationID=${M_WTP_LocationID}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            // console.log(result.data1, result.data) 
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleGetExport && handleGetExport()
                return result.data

            } else {
                return result
            }
        })
})

const WTPOperationalWorkTableExportDataSlice = createSlice({
    name: "WTPOperationalWorkTableExportData",
    initialState: {
        isExportLoading: false,
        ExporttableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPOperationalWorkTableExportDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(WTPOperationalWorkTableExportDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.ExporttableData = action.payload;
        });
        builder.addCase(WTPOperationalWorkTableExportDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.ExporttableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const WTPOperationalWorkTableExportDataReducer = WTPOperationalWorkTableExportDataSlice.reducer


// Delete Api

export const WTPOperationalWorkDeleteAPI = createAsyncThunk("WTPOperationalWorkDelete", async ({ data }) => {
    const {
        T_WTP_MaintainanceWork_PreventiveID,
        M_UserID,
        token,
        handleIsPost
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);


    var formdata = new FormData();
    formdata.append("T_WTP_MaintainanceWork_PreventiveID", T_WTP_MaintainanceWork_PreventiveID);
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    fetch(`${BaseUrl}/Master/WEB_WTP_T_WTP_MaintainanceWork_Preventive_Delete`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                toastSuccesss(result.message)
            } else {
                toastErrorr(result.message)

            }
            return result

        })
})

const WTPOperationalWorkDeleteSlice = createSlice({
    name: "WTPOperationalWorkDelete",
    initialState: {
        isDeleteLoading: false,
        SectorData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPOperationalWorkDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(WTPOperationalWorkDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.SectorData = action.payload;

        });
        builder.addCase(WTPOperationalWorkDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.SectorData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const WTPOperationalWorkDeleteReducer = WTPOperationalWorkDeleteSlice.reducer
